export const isValidEmail = (email, domainCheck = false) => {
  if (domainCheck) {
    return /.@.*\./.test(email);
  }

  return /.@./.test(email);
};
